import React from 'react';
import { Nav, Pagination, Row, Col } from 'react-bootstrap';

import { ConversationItem } from './ConversationItem';
import Conversations from '../../../../Models/Conversations';
import { AddCircleIcon } from '../../Icons';

interface ConversationListProps {
  conversations: Conversations[];
  activeConvId: string | null;
  currentPage: number;
  totalPages: number;
  onNewChat: () => void;
  onCloseConversation: (id: string) => Promise<void>;
  onDeleteConversation: (id: string) => Promise<void>;
  onPageChange: (page: number) => void;
  timeAgo: (date: string) => string;
}

export const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  activeConvId,
  currentPage,
  totalPages,
  onNewChat,
  onCloseConversation,
  onDeleteConversation,
  onPageChange,
  timeAgo,
}) => (
  <>
    <Row className='border-bottom mx-0'>
      <Col sm={6} as='h2' className='m-0 py-3'>Recent</Col>
      <Col sm={6} className="m-0 py-3 text-end">
        <AddCircleIcon
          width={30}
          onClick={onNewChat}
          className="my-auto py-1 pe-link text-secondary"
        />
      </Col>
    </Row>

    <Nav className='flex-column' variant='pills' activeKey={activeConvId ?? undefined}>
      {conversations.map((conv) => {
        const isActive = conv.id === activeConvId;
        const conversationWithUnread = isActive
          ? { ...conv, unreadMessagesCount: 0 }
          : conv;
        return (
          <ConversationItem 
            key={conv.id} 
            conversation={conversationWithUnread} 
            timeAgo={timeAgo}
            onClose={onCloseConversation}
            onDelete={onDeleteConversation}
          />
        );
      })}
    </Nav>

    <Pagination className="pagination bg-basic w-100 bottom-0 position-absolute">
      {[...Array(totalPages)].map((_, index) => (
        <Pagination.Item
          key={index + 1}
          active={index + 1 === currentPage}
          onClick={() => onPageChange(index + 1)}
        >
          {index + 1}
        </Pagination.Item>
      ))}
    </Pagination>
  </>
);


